import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import { FormattedMessage } from 'react-intl';
var ProgramUsersInfo = function ProgramUsersInfo(props) {
  var receiving_referrals = props.program.receiving_referrals,
    showProgramUsersInfo = props.showProgramUsersInfo;
  if (!receiving_referrals || !showProgramUsersInfo) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "program-details-user-info"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "program-details-user-info__icon",
    icon: "V2Warning",
    color: "#2C405A"
  }), /*#__PURE__*/React.createElement("div", {
    className: "program-details-user-info__text"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "gWEbfN",
    description: "user-info-text",
    defaultMessage: "Please make sure at least one user from your organization is assigned to this program. Go to the Users tab to add users to your organization and assign them to programs."
  })));
};
ProgramUsersInfo.propTypes = {
  program: PropTypes.shape({
    receiving_referrals: PropTypes.bool.isRequired
  }).isRequired,
  showProgramUsersInfo: PropTypes.bool.isRequired
};
export default ProgramUsersInfo;